module.exports = "<jujo_component specialized=\"false\" comp=\"jujo_grid\" c_key=\"print_file_list\" entity=\"print_file\"></jujo_component>"